import React, { useState, Fragment, useContext } from 'react';
import { sidebarRoutes } from '../../router/sidebarRoutes';
import { SidebarItem } from '../SidebarItem';
import { containEmail } from '../../utils/utils';
import { StoreContext } from '../../business/Provider';
import { ACESS_ROLE_ADMINISTRATOR } from '../../business/constants';
import useReload from '../../hooks/useReload';
import useAccess from '../../hooks/access/useAccess';

export const Sidebar = () => {
  const { getAccess, getAccessCompanies, getAccessRole } =useAccess();

	const [dataSecondSidebar, setDataSecondSidebar] = useState([]);
	const { loadingState, loadingContextState, getAccessRoleState } = useContext(StoreContext);

  useReload([getAccessCompanies, getAccess, getAccessRole]);

	const { stateLoadingWithMessage } = loadingContextState;
	const [isSelect, setIsSelect] = useState(false);
	// open hook for each sidebar item
	const reduceSidebar = sidebarRoutes?.reduce((acc, item) => {
		acc[item.id] = false;
		return acc;
	}, {});
	const [open, setOpen] = useState(reduceSidebar);

	function includeEmailInList(list) {
		const validate = containEmail();

		list.forEach((item) => {
			if (item.id === 'assist') {
				item.show = validate;
			}
		});

		return list;
	}
	const validatePilote = window.REACT_APP_WHITELIST_ENABLED;

	const newFilterList =
		validatePilote === true || validatePilote === 'true'
			? includeEmailInList(sidebarRoutes)
			: sidebarRoutes;

	var accessFlag = false;
	
	if (getAccessRoleState.accessRole?.data?.data) {
		const { isOwner, roleId } = getAccessRoleState.accessRole.data.data;

		if (!isOwner && roleId !== ACESS_ROLE_ADMINISTRATOR) {
			accessFlag = false;
		}
		else{
			accessFlag = true;
		}
	}

	const grantedAccessNames = getAccessRoleState.accessRole?.data?.data?.accesses
		?.filter(a => a.grant === true || a.grant === null)
		?.map(a => a.accessName) || [];

	const processedSidebarList = newFilterList.map(item => {
		// Siempre parte de show: false
		let show = false;

		// Acceso especial para accessControl
		if (item.id === 'accessControl') {
			show = accessFlag;
		}
		// Permiso explícito por access
		else if (item.access && grantedAccessNames.includes(item.access)) {
			show = true;
		}

		return {
			...item,
			show
		};
	});

return (
	<ul className="flex h-full w-[90px] z-50 drop-shadow-2xl flex-col bg-brand-primary-500">
		{processedSidebarList
			.filter(item => item.show) // solo los visibles
			.map((item, keyItem) => (
				<Fragment key={keyItem.toString()}>
					<SidebarItem
						loadingState={loadingState || stateLoadingWithMessage.loading}
						itemSidebar={item}
						isSelectValue={isSelect}
						setIsSelect={setIsSelect}
						setDataSecondSidebar={setDataSecondSidebar}
						dataSecondSidebar={dataSecondSidebar}
						open={open}
						setOpen={setOpen}
					/>
				</Fragment>
			))}
	</ul>
);
};
